import React from 'react';
import { ConfigProvider } from 'antd';
import { ConfigProvider as MobileConfigProvider } from 'antd-mobile';
import enUSMobile from 'antd-mobile/es/locales/en-US';
import { Outlet } from 'react-router-dom';
import { FlexUserLayoutProvider } from '@/context/FlexUserLayoutContext';
import { useMediaQuery } from 'react-responsive';
import MobileNavBar from './MobileHeader';
import BottomTabBar from './MobileBottomTabBar';
import { If } from '@/components';
import styles from './FlexUserAppLayout.module.pcss';
import { ReactComponent as Union } from '@/assets/organization-logos/Union.svg';

export default function FlexUserLayout() {
  const isMobile = useMediaQuery({ query: '(max-width: 900px)' });

  return (
    <FlexUserLayoutProvider>
      <ConfigProvider
        theme={{
          token: {
            fontFamily: 'Inter',
            colorPrimary: '#0fa06f',
          },
          components: {
            Button: {
              colorBorder: '#1f1f1f',
              borderRadius: 8,
            },
            List: {
              borderRadius: 8,
              colorBorder: '#1f1f1f',
            },
            Slider: {
              colorPrimaryBorder: 'rgba(49, 196, 141, 1)',
              colorPrimaryBorderHover: 'rgba(49, 196, 141, 1)',
              colorFillContentHover: '#1f1f1f',
            },
          },
        }}
      >
        <MobileConfigProvider locale={enUSMobile}>
          <If condition={isMobile}>
            <div className={styles.mobile}>
              <div className={styles.top}>
                <MobileNavBar />
              </div>
              <div className={styles.body}>
                <Outlet />
              </div>
              <div className={styles.bottom}>
                <BottomTabBar />
              </div>
            </div>
          </If>
          <If condition={!isMobile}>
            <section className={styles.desktopView}>
              <div className={styles.intro}>
                <Union />
                <h1> Welcome to Arya </h1>
                <h2>
                  Our Desktop app is coming soon. In the meantime, all of the same functionality from mobile is
                  available here.
                </h2>
              </div>
              <section className={styles.mobileInDesktop}>
                <div className={styles.desktopWrapper}>
                  <div className={styles.topDesktop}>
                    <MobileNavBar />
                  </div>
                  <div className={styles.bodyDesktop}>
                    <Outlet />
                  </div>
                  <div className={styles.bottomDesktop}>
                    <BottomTabBar />
                  </div>
                </div>
              </section>
              <div className={styles.intro}></div>
            </section>
          </If>
        </MobileConfigProvider>
      </ConfigProvider>
    </FlexUserLayoutProvider>
  );
}
